const PageShell = () => <div className="shell-loader my-profile__shell" />

export default PageShell
